import { cn, createBEM } from "@/libs";
import { Space, Button, Toast, AutoCenter, Image, Dialog } from "antd-mobile";
import { ReactNode, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CopyIcon } from "../CopyIcon";
import { Icon } from "../Icon";
import "./index.scss";
import { DialogLocal } from "../Dialog";
import { Input } from "../Input";
import { getImageCode } from "@/apis/common";
import { checkAddress } from "@/apis/user";
import { useSetState } from "ahooks";
import { useUserInfoStore } from "@/stores/userInfo";
type TextWithCopyProps = {
  text: string;
  prefix?: string | ReactNode;
  className?: string;
  encryption?: boolean; //是否显示加密文字
  isWalletAddress?: boolean; //是否是钱包地址复制
};
function generateString(text: string) {
  let result = '';
  let char = '*';
  let length = text.length;
  for (let i = 0; i < length; i++) {
    result += char;
  }
  return text.replace(text.substring(0, text.length), result);
}
export const CopyIconWithText = (props: TextWithCopyProps) => {
  const b = createBEM("i-copytext");
  const [text, setText] = useState(props.text || '');
  const pwdRef = useRef<string>('');
  const codeRef = useRef<string>('');
  const [state, setState] = useSetState({
    verifyUniqid: "",
    verifyCode: ""
  });
  const [visible, setVisible] = useState(false);
  const [encryptionStatus, setEncryptionStatus] = useState(true);
  const [userinfo] = useUserInfoStore()(state => [state.userInfo]);
  const navigate = useNavigate();
  useEffect(() => {
    if (props.encryption && encryptionStatus && props.text) {
      setText(generateString(props.text));
    } else {
      setText(props.text);
    }
  }, [encryptionStatus]);
  const onConfirm = async () => {
    if (!pwdRef?.current || pwdRef.current.length === 0) {
      Toast.show('请输入资金密码！');
      return false;
    }
    if (pwdRef.current.length < 6) {
      Toast.show('资金密码为6位数！');
      return false;
    }
    if (!codeRef?.current || codeRef.current.length === 0) {
      Toast.show('请输入验证码！');
      return false;
    }
    const {
      data,
      msg
    } = await checkAddress({
      securePassword: pwdRef.current,
      code: codeRef.current,
      verifyUniqid: state.verifyUniqid
    });
    if (data === true) {
      setEncryptionStatus(false);
      return true;
    } else {
      Toast.show(msg);
      flushCodeImage();
      return false;
    }
  };
  const flushCodeImage = async () => {
    const response = await getImageCode({
      codeType: "checkPassword"
    });
    if (response.ok) {
      setState({
        verifyCode: response.data?.verifyCode || "",
        verifyUniqid: response.data?.verifyUniqid || ""
      });
    } else {
      Toast.show(response.msg);
    }
    return Promise.resolve();
  };
  const RenderDialog = () => {
    return <Dialog visible={visible} content={<div className={cn('check_pass')}>
            <h2>提示</h2>
            <p>切勿私聊提供钱包地址，如果造成资金损失自行负责!</p>
            <Input placeholder="请输入资金密码！" type="password" onChange={e => {
        pwdRef.current = e.target.value;
      }} maxLength={6} max={6} />
            <div className={cn('verify_code_box')}>
              <Input placeholder="请输入验证码" type="text" onChange={e => {
          codeRef.current = e.target.value;
        }} maxLength={6} max={6} />
              <Image className={cn('verify_code')} src={state.verifyCode} alt="code" onClick={() => flushCodeImage()} />
            </div>
          </div>} onClose={() => {
      setVisible(false);
    }} actions={[[{
      key: 'confirm',
      text: '确定',
      className: cn('check_pass_btn'),
      onClick: async () => {
        let visibleStatus = await onConfirm();
        visibleStatus && setVisible(false);
      }
    }, {
      key: 'close',
      text: '取消',
      className: cn('check_pass_btn_def'),
      onClick: () => {
        setVisible(false);
      }
    }]]} data-sentry-element="Dialog" data-sentry-component="RenderDialog" data-sentry-source-file="index.tsx" />;
  };
  const checkEncryptionStatus = async (e: any) => {
    e.stopPropagation();
    if (props.isWalletAddress) {
      if (!encryptionStatus) {
        setEncryptionStatus(!encryptionStatus);
      } else {
        if (!userinfo.secPasswordStatus) {
          DialogLocal({
            cancelText: "取消",
            content: <AutoCenter>查看钱包地址，请先设置您的资金密码！</AutoCenter>,
            onConfirm() {
              navigate(`/user_pay_psw`);
            }
          });
        } else {
          await flushCodeImage();
          setVisible(true);
        }
      }
    } else {
      setEncryptionStatus(!encryptionStatus);
    }
  };
  return <Space className={cn(b(), props.className)} align="center" data-sentry-element="Space" data-sentry-component="CopyIconWithText" data-sentry-source-file="index.tsx">
      <span>{props.prefix}</span>
      <span className={props.encryption && encryptionStatus ? cn('encryption_txt') : ''}>{text}</span>
      {
    // 展示 隐藏显示眼睛按钮
    props.encryption && props.text ? <Button fill="none" onClick={checkEncryptionStatus} style={{
      cursor: "pointer"
    }}>
            <Icon name={encryptionStatus ? "psw-hide" : "psw-show"} size={"16px"} />
          </Button> : null}
      
      <CopyIcon text={text} isWalletAddress={props.isWalletAddress} data-sentry-element="CopyIcon" data-sentry-source-file="index.tsx" />
      <RenderDialog data-sentry-element="RenderDialog" data-sentry-source-file="index.tsx" />
    </Space>;
};